# import InvitationFragment from "../fragments/invitation.graphql"

query getInvitation($id: ID) {
  invitation(id: $id) {
    ...InvitationFragment
  }
}
